import { render, staticRenderFns } from "./ResourcesManager.vue?vue&type=template&id=100e241b&scoped=true&"
import script from "./ResourcesManager.vue?vue&type=script&lang=js&"
export * from "./ResourcesManager.vue?vue&type=script&lang=js&"
import style0 from "./ResourcesManager.vue?vue&type=style&index=0&id=100e241b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100e241b",
  null
  
)

export default component.exports